import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../Store/AuthContext";
import axios from "axios";
import APIDataFetchLoader from "../Others/APIDataFetchLoader";
import NotifyMessageNoReload from "../Others/NotifyMessageNoReload";

const SiteUrl = process.env.REACT_APP_SITEURL;
const WebsiteAPIurl = SiteUrl + "api/Webapi/";

export default function PaymentLinkwork() {
  const { RendomTokenfetch, userID } = useAuth();
  // const { linkid } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [PaymentLink, setPaymentLink] = useState("");
  console.log(PaymentLink);

  const getLastSegment = () => {
    const path = window.location.pathname;
    const segments = path.split("/").filter(Boolean);
    return segments[segments.length - 1];
  };

  useEffect(() => {
    setLoading(true);
    let fdata = new FormData();
    fdata.append("user_id", userID);
    fdata.append("linkid", getLastSegment());
    const FetchVendorStatusData = async () => {
      try {
        await axios
          .post(`${WebsiteAPIurl}payment_link_generate`, fdata, {
            headers: {
              Authorization: RendomTokenfetch,
            },
          })
          .then((response) => {
            // console.log("API Response:", response.data);
            if (response.data.Status === "1") {
              setPaymentLink(response.data.payment_link || "");
              if (response.data.payment_link) {
                window.location.href = response.data.payment_link;
              }
            } else {
              NotifyMessageNoReload(response.data.message, "danger", true);
              navigate("/payment-invalid-link");
              setPaymentLink("");
            }
          });
      } catch (err) {
        console.log(err.message);
      } finally {
        setLoading(false);
      }
    };
    FetchVendorStatusData();
  }, [RendomTokenfetch, userID, navigate]);

  if (loading) {
    return <APIDataFetchLoader />;
  }

  return (
    <>
      {/* <div className="m-5 p-5 text-center">
        <h1 className="text-success ">Payment Success</h1>
        <h1>Link ID : {linkid}</h1>
      </div> */}
    </>
  );
}
